document.addEventListener("DOMContentLoaded", function () {
    const toggleBtn = document.getElementById("contact-toggle-btn");
    const contactPanel = document.getElementById("contact-panel");
  
    if (!toggleBtn || !contactPanel) {
      console.warn("Contact widget elements not found");
      return;
    }
  
    toggleBtn.addEventListener("click", function () {
      const isActive = contactPanel.classList.contains("contact-widget__panel--active");
  
      if (isActive) {
        contactPanel.classList.remove("contact-widget__panel--active");
        toggleBtn.classList.remove("contact-widget__toggle-btn--active");
      } else {
        contactPanel.classList.add("contact-widget__panel--active");
        toggleBtn.classList.add("contact-widget__toggle-btn--active");
      }
    });
  
    document.addEventListener("click", function (event) {
      const isClickInsidePanel = contactPanel.contains(event.target);
      const isClickOnToggle = toggleBtn.contains(event.target);
  
      if (
        !isClickInsidePanel &&
        !isClickOnToggle &&
        contactPanel.classList.contains("contact-widget__panel--active")
      ) {
        contactPanel.classList.remove("contact-widget__panel--active");
        toggleBtn.classList.remove("contact-widget__toggle-btn--active");
      }
    });
  });
  